import template from './finance-reports.pug';

export const FinancesReportsComponent = {
  template,
  controller: class FinancesReportsComponent {
    constructor($async, $state, $stateParams, Finance, TableEdit, $localStorage) {
      'ngInject';

      this.Finance = Finance;
      this.$state = $state;
      this.$stateParams = $stateParams;
      this.TableEdit = TableEdit;
      this.$localStorage = $localStorage;
      this.getRecords = $async(this.getRecords.bind(this));
      this.newFinance = $async(this.newFinance.bind(this));
      this.getTotalRecords = $async(this.getTotalRecords.bind(this));

      this.filter = {};
      this.totalRecords = 1; // Set initial value to show the table
    }

    $onInit() {
      this.filter = {
        page: this.$stateParams.page || 1
      };

      if (this.$stateParams.status) {
        this.filter.status = this.$stateParams.status;
      }

      if (this.$stateParams.group_id) {
        this.filter.group_id = parseInt(this.$stateParams.group_id);
      }

      // Handle custom fields if present
      if (this.$stateParams.customFieldId && this.$stateParams.destinationId && this.$stateParams.destinationType) {
        this.filter.customFieldId = this.$stateParams.customFieldId;
        this.filter.destinationId = this.$stateParams.destinationId;
        this.filter.destinationType = this.$stateParams.destinationType;
      }

      this.getRecords();
      this.getTotalRecords();
    }

    async getTotalRecords() {
      try {
        this.totalRecords = await this.Finance.totalFinanceRecords();
        console.log('total', this.totalRecords);
      } catch (err) {
        console.error('Error getting total records:', err);
      }
    }

    updateState() {
      const params = { ...this.$stateParams };
      
      // Always include page parameter
      params.page = this.filter.page || 1;
      
      if (this.filter.status) {
        params.status = this.filter.status;
      } else {
        delete params.status;
      }

      if (this.filter.group_id) {
        params.group_id = this.filter.group_id;
      } else {
        delete params.group_id;
      }

      this.$state.go('.', params, { 
        notify: false,
        reload: false,
        location: 'replace',
        inherit: false
      });
    }

    applyFilterAndResetPage(event) {
      if (!event || !event.filter) {
        return;
      }

      // Create new filter object with required page parameter
      this.filter = {
        page: 1,  // Always include page
        ...event.filter
      };

      // Handle custom fields if present
      if (this.$stateParams.customFieldId && this.$stateParams.destinationId && this.$stateParams.destinationType) {
        this.filter.customFieldId = this.$stateParams.customFieldId;
        this.filter.destinationId = this.$stateParams.destinationId;
        this.filter.destinationType = this.$stateParams.destinationType;
      }

      this.updateState();
      this.getRecords();
    }

    updatePage(event) {
      if (!event) return;

      const page = parseInt(event.page) || 1;
      this.filter = {
        ...this.filter,
        page
      };

      this.updateState();
      this.getRecords();
    }

    async newFinance() {
      try {
        const result = await this.Finance.newModal();
        if (result && result.id) {
          // Reset filter to show all records and refresh
          this.filter = { page: 1 };
          this.updateState();
          await this.getRecords();
        }
      } catch (err) {
        console.error('Error creating new finance record:', err);
      }
    }

    async getRecords() {
      try {
        if (!this.filter) {
          this.filter = { page: 1 };
        }

        const { data: records, meta } = await this.Finance.getListByFilters(this.filter);
        this.records = records;
        this.totalPages = meta.pages;
        this.totalCount = meta.total_count;
        this.reportsSum = meta.info_blocks;
        this.statusCounts = meta.status_counts || {
          paid: 0,
          pending: 0,
          not_paid: 0
        };

        if (meta.cf_names && meta.cf_names.length) {
          let settings = await this.$localStorage.settings['finance']['custom_table_fields'];
          settings.cf_names = meta.cf_names;
          const resp = this.TableEdit.recheckNames(settings, 'finance');
          if (resp.update) {
            this.gridOptions.columnDefs = this.TableEdit.resolveColumns(
              'finance',
              'finances',
              this.isModal
            );
          }
        }
      } catch (err) {
        console.error('Error loading finance records:', err);
        this.records = [];
        this.totalPages = 0;
        this.totalCount = 0;
        this.reportsSum = null;
        this.statusCounts = {
          paid: 0,
          pending: 0,
          not_paid: 0
        };
      }
    }
  }
};
